// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tooltip-wrapper[data-v-2daa822c]{\n  display: flex;\n  align-items: center;\n  z-index: 99;\n}\n.cd-tooltip-icon-button[data-v-2daa822c] {\n  --vvd-icon-button-icon-size: 32px;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
